import { Quote } from 'lucide-react';
import { Card, CardBody, Skeleton } from '@vnetwork/ui/primitives';
import { useRandomQuote } from '@/api/dashboard';

/**
 * "Quote of the day" banner — full-width hero row (mockup: Châm ngôn trong ngày).
 * Real data from /quotes/random.
 */
export function QuoteBanner() {
  const { data: quote, isLoading } = useRandomQuote();

  return (
    <Card
      flat
      style={{
        background:
          'linear-gradient(90deg, var(--vn-warning-subtle) 0%, var(--vn-bg-surface) 70%)',
        borderColor: 'var(--vn-warning-border)',
      }}
    >
      <CardBody>
        <div style={{ display: 'flex', gap: 'var(--vn-space-3)', alignItems: 'flex-start' }}>
          <span
            style={{
              display: 'inline-flex',
              padding: 'var(--vn-space-2)',
              borderRadius: 'var(--vn-radius-md)',
              background: 'var(--vn-warning-solid)',
              color: 'var(--vn-fg-on-solid)',
            }}
          >
            <Quote size={18} />
          </span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              style={{
                fontSize: 'var(--vn-font-size-sm)',
                fontWeight: 'var(--vn-font-weight-semibold)',
                color: 'var(--vn-fg-default)',
              }}
            >
              Quote of the day
            </div>
            {isLoading ? (
              <Skeleton style={{ height: 20, width: '60%', marginTop: 'var(--vn-space-1)' }} />
            ) : (
              <p
                style={{
                  margin: '4px 0 0',
                  fontStyle: 'italic',
                  color: 'var(--vn-fg-muted)',
                  fontSize: 'var(--vn-font-size-md)',
                }}
              >
                “{quote?.content || 'Give today your all so tomorrow holds no regrets.'}”
              </p>
            )}
            <div
              style={{
                marginTop: 'var(--vn-space-1)',
                textAlign: 'right',
                fontSize: 'var(--vn-font-size-xs)',
                fontWeight: 'var(--vn-font-weight-semibold)',
                color: 'var(--vn-warning-text)',
              }}
            >
              — {quote?.author || quote?.created_by_name || 'VNETWORK JSC'}
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
